
const initSearchForm = () => {
  const searchButton = document.querySelector('#show-search');
  
  if (searchButton) {
    const searchForm = document.querySelector('#searchform');

    searchButton.addEventListener('click', (event) => {
      event.preventDefault();
      searchForm.style.display = searchForm.style.display === 'block' ? 'none' : 'block';
      searchButton.classList.toggle('active');
    });
  }
};

export default initSearchForm;
